import { INSURANCE_PAYER_SCHOOL_IDS } from "@marble/core/modules/schools/payer-schools/constants";
import { IS_PRODUCTION } from "@marble/core/utils/environment";

// THIS IS A WORKAROUND TO MAKE SIGN UP CLEARER FOR NYC Health + Hospital Users (aka "Pediatricians")
export const NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID = IS_PRODUCTION ? 15503 : 56038;

/**
 * Schools whose workers get no counselor comms (onboarding emails, referral
 * follow-ups): the insurance-payer "schools" and NYC Health + Hospitals.
 */
export const SUPPRESSED_COMMS_SCHOOL_IDS = [
  ...INSURANCE_PAYER_SCHOOL_IDS,
  NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID,
];
